export interface Localized<T> {
  value: T;
  label?: string;

  localizationKey: string | string[];
  localizationParams?: any;
}

export interface LocalizedMoment extends Localized<moment.Moment> {
  localizationKey: string;
}

export const isLocalized = <T>(value: any): value is Localized<T> => {
  return value && value.localizationKey != null;
}

export const isLocalizedMoment = (value: any): value is LocalizedMoment => {
  return isLocalized(value) && moment.isMoment(value.value);
}

